import { AfterViewInit, ChangeDetectorRef, Component } from '@angular/core';
import { combineLatest } from 'rxjs';
import { BaseComponent } from '../../../../components/base/base.component';
import { DashboardHelper } from '../../../../services/dashboard.service';
import { BlueprintStore } from '../../../../services/stores/blueprint.store';
import {
  BLUEPRINT_NAVIGABLE_PANEL_TITLES_LOWER,
  BLUEPRINT_NAV_NEXT,
  BLUEPRINT_NAV_NEXT_TOOLTIP,
  BLUEPRINT_NAV_PREVIOUS,
  BLUEPRINT_NAV_PREVIOUS_TOOLTIP,
  BlueprintNavigationDirection,
} from '../../../../modules/catch-core/data/constants/blueprint.constants';

@Component({
  selector: 'app-shared-right-panel-header',
  templateUrl: './shared-right-panel-header.component.html',
  styleUrl: './shared-right-panel-header.component.scss',
  standalone: false,
})
export class SharedRightPanelHeaderComponent extends BaseComponent implements AfterViewInit {
  public title: string = '';
  public readonly navPrevious = BLUEPRINT_NAV_PREVIOUS;
  public readonly navNext = BLUEPRINT_NAV_NEXT;
  public readonly navPreviousTooltip = BLUEPRINT_NAV_PREVIOUS_TOOLTIP;
  public readonly navNextTooltip = BLUEPRINT_NAV_NEXT_TOOLTIP;
  constructor(
    public dashboardHelper: DashboardHelper,
    private cdr: ChangeDetectorRef,
    private blueprintStore: BlueprintStore,
  ) {
    super();
  }

  public get showBlueprintNavigation(): boolean {
    // The root panel is excluded: it has no neighbours to move to.
    const title = this.title?.trim().toLowerCase();
    return this.blueprintStore.blueprintEditorActive && !!title && BLUEPRINT_NAVIGABLE_PANEL_TITLES_LOWER.includes(title);
  }

  public onNavigate(direction: BlueprintNavigationDirection): void {
    this.dashboardHelper.requestBlueprintNavigation(direction);
  }

  ngAfterViewInit(): void {
    // Navigation depends on both the panel title and the blueprint editor being open, so react to either changing.
    this.subscribers.sharedRightPanelHeaderTitle = combineLatest([this.dashboardHelper.sharedRightPanelHeaderTitle, this.blueprintStore.$blueprintEditorActive]).subscribe(([res]) => {
      if (res) {
        this.title = res;
      }
      this.dashboardHelper.setPanelEdgeToggleVisible(this, this.showBlueprintNavigation);
      if (res) {
        this.cdr.detectChanges();
      }
    });
  }

  onCloseShortRightPanel() {
    this.dashboardHelper.setSharedRightPanelHeaderTitle('');
    this.dashboardHelper.setShowRightPanel(false);
    this.dashboardHelper.setExpandRightPanel(false);
    this.dashboardHelper.showVideoList = false;
    this.dashboardHelper.showProfile = false;
  }

  ngOnDestroy(): void {
    this.dashboardHelper.setPanelEdgeToggleVisible(this, false);
    this.dashboardHelper.setSharedRightPanelHeaderTitle('');
  }
}
